import { ConfigProvider } from 'antd';
import arEG from 'antd/locale/ar_EG';
import enUS from 'antd/locale/en_US';
import { lazy, Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import { getThemeMode } from '../../store/Theme/ThemeSlice';
import { loadLanguage } from '../../store/Language/LanguageSlice';
import Loading from '../Loading/Loading';

const AppRoutes = () => {
  const dispatch = useDispatch();
  const { theme } = useSelector((state) => state.theme);
  const { language } = useSelector((state) => state.language);

  const cairoFont = "'Cairo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Ubuntu', sans-serif";
  const lightTheme = {
    token: {
      colorBgBase: '#fff',
      colorTextQuaternary: '#828181',
      ...(language === 'ar' ? { fontFamily: cairoFont } : {}),
    },
  };

  const darkTheme = {
    token: {
      colorBgBase: '#001529',
      colorPrimaryBg: '#001529',
      colorText: 'white',
      colorTextQuaternary: '#aeb0af',
      controlOutlineWidth: '0',
      colorErrorBg: '#ff4d4f',
      ...(language === 'ar' ? { fontFamily: cairoFont } : {}),
    },
  };

  useEffect(() => {
    dispatch(getThemeMode());
    dispatch(loadLanguage());
  }, [dispatch]);

  const PrivateRoute = lazy(() => import('../Routes/PrivateRoute'));
  const BackofficeVendors = lazy(() => import('../../pages/Backoffice/Vendors'));
  const BackofficeVendorForm = lazy(() => import('../../pages/Backoffice/VendorForm'));
  const BackofficeVendorEdit = lazy(() => import('../../pages/Backoffice/VendorEdit'));
  const BackofficeSubscriptionPlans = lazy(() => import('../../pages/Backoffice/SubscriptionPlans'));
  const BackofficeSubscriptions = lazy(() => import('../../pages/Backoffice/Subscriptions'));
  const Profile = lazy(() => import('../../pages/Profile/Profile'));
  const Activities = lazy(() => import('../../pages/Activities/Activities'));

  return (
    <>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route
            path="/"
            element={
              <ConfigProvider locale={language === 'ar' ? arEG : enUS} direction={language === 'ar' ? 'rtl' : 'ltr'} theme={theme === 'dark' ? darkTheme : lightTheme}>
                <PrivateRoute />
              </ConfigProvider>
            }
          >
            <Route index element={<Navigate to="/vendors" replace />} />
            <Route path="vendors" element={<BackofficeVendors />} />
            <Route path="vendors/create" element={<BackofficeVendorForm />} />
            <Route path="vendors/:id/edit" element={<BackofficeVendorEdit />} />
            <Route path="subscription-plans" element={<BackofficeSubscriptionPlans />} />
            <Route path="subscriptions" element={<BackofficeSubscriptions />} />
            <Route path="profile" element={<Profile />} />
            <Route path="activities" element={<Activities />} />
            <Route path="*" element={<Navigate to="/vendors" replace />} />
          </Route>
        </Routes>
      </Suspense>
    </>
  );
};

export default AppRoutes;
